class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.limit = parseInt(this.dataset.limit) || 4;
    this.intent = this.dataset.intent || "related";
  }

  connectedCallback() {
    this.loadRecommendations();
    // this.loadRecommendations();
    // Listen for cart updates to refresh recommendations
    // document.addEventListener("cart:updated", () => {
    //   this.loadRecommendations();
    // });
  }

  async loadRecommendations() {
    try {
      const cart = await this.fetchCart();

      if (!cart.items || cart.items.length === 0) {
        this.innerHTML = "";
        return;
      }

      this.innerHTML = `
            <div class="cart-recommendations__loader">
        <span class="loader"></span>
      </div>
      `;

      const recommendations = await this.fetchRecommendations(cart.items);
      this.render(recommendations);
    } catch (error) {
      console.error("Error loading cart recommendations:", error);
    }
  }

  async fetchCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  async fetchRecommendations(cartItems) {
    const cartProductIds = new Set(cartItems.map((item) => item.product_id));
    const productRecommendations = {};

    // Fetch recommendations for each cart item
    const recommendationPromises = cartItems.map((item) =>
      fetch(
        `${window.Shopify.routes.root}recommendations/products.json?product_id=${item.product_id}&limit=${this.limit}&intent=${this.intent}`,
      )
        .then((res) => res.json())
        .catch((err) => {
          console.error(
            `Failed to fetch recommendations for product ${item.product_id}:`,
            err,
          );
          return { products: [] };
        }),
    );

    const results = await Promise.all(recommendationPromises);

    // Aggregate recommendations and count frequency
    results.forEach((data) => {
      if (!data.products) return;

      data.products.forEach((product) => {
        // Skip products already in cart
        if (cartProductIds.has(product.id)) return;

        if (productRecommendations[product.id]) {
          productRecommendations[product.id].count += 1;
        } else {
          productRecommendations[product.id] = {
            product: product,
            count: 1,
          };
        }
      });
    });

    // Sort by frequency (most recommended first)
    return Object.values(productRecommendations)
      .sort((a, b) => b.count - a.count)
      .map((rec) => rec.product)
      .slice(0, this.limit);
  }

  render(products) {
    if (products.length === 0) {
      this.innerHTML = "";
      return;
    }

    this.innerHTML = `
        <div class="cart-recommendations__container">
          ${products.map((product) => this.renderProduct(product)).join("")}
        </div>
    `;
  }

  renderProduct(product) {
    const imageUrl = product.featured_image
      ? `${product.featured_image}&width=300`
      : "";
    const price = this.formatPrice(product.price);
    const compareAtPrice =
      product.compare_at_price > product.price
        ? this.formatPrice(product.compare_at_price)
        : null;

    return `
            <div class="recommended-product__wrapper">
            <a href="${product.url}" class='recommended-product__a'>
            <div class="recommended-product__image-wrapper">
              <img
                  class="recommended-product__image"
                  src="${imageUrl}"
                  onload="this.alt='${this.escapeHtml(product.title)}'"
                        onerror="this.alt='Product image unavailable'"
                  loading="lazy"
                  />
            </div>
                <div class="recommended-product__information">
                <p class="recommended-product__label">${product.title}</p>
                <p>${price}</p>
                </div>
            </a>
        </div>
      
    `;
  }

  formatPrice(cents) {
    const amount = cents / 100;

    // Try to use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    // Fallback to basic formatting
    return new Intl.NumberFormat("en-PH", {
      style: "currency",
      currency: "PHP",
    }).format(amount);
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define("cart-recommendations", CartRecommendations);
